import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function SuccessIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18.333 9.234V10a8.333 8.333 0 1 1-4.941-7.616" />
        <path d="M18.333 3.333 10 11.675l-2.5-2.5" />
      </g>
    </Icon>
  );
}
